import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { PurchaseMotionCTA } from 'purchase-motions-components/components/PurchaseMotionCTA/PurchaseMotionCTA';
import { LoadingPlaceHolder } from '../LoadingPlaceholder';
import { useFeatureTableSessionCache } from '../FeatureTableSessionCacheProvider';
import { useBuyingMotionProps, useCachedCurrency, useCurrencyAndPurchaseOptions } from '../data-cache/dataCacheHooks';
import { tryAndGetEligiblePurchaseOptionByTerm } from '../data-cache/fetchPurchaseOptions';
import { jsx as _jsx } from "react/jsx-runtime";
const PurchaseMotionContainer = ({
  children
}) => {
  return /*#__PURE__*/_jsx(View, {
    paddingInline: "300",
    marginBlockEnd: "500",
    blockSize: "40px",
    children: children && children
  });
};
export const PurchaseMotionWrapper = ({
  productApiName,
  purchaseMotion
}) => {
  var _purchaseOptionsAndCu, _purchaseOptionsAndCu2, _window$hubspot;
  const {
    isUpgradePoint,
    onPurchaseMotionButtonClick,
    purchaseMotionLocation,
    revenueAttributionUniqueId,
    term
  } = useFeatureTableSessionCache();
  const purchaseOptionsAndCurrencyByProductApiName = useCurrencyAndPurchaseOptions();
  const buyingMotionProps = useBuyingMotionProps();
  const cachedCurrency = useCachedCurrency();
  if (purchaseMotion === undefined) {
    return /*#__PURE__*/_jsx(PurchaseMotionContainer, {
      children: /*#__PURE__*/_jsx(LoadingPlaceHolder, {
        width: 100,
        height: 40
      })
    });
  }
  if (purchaseMotion === null) {
    return /*#__PURE__*/_jsx(PurchaseMotionContainer, {});
  }
  if (purchaseMotion === 'CURRENT_PLAN') {
    return /*#__PURE__*/_jsx(PurchaseMotionContainer, {
      children: /*#__PURE__*/_jsx(Button, {
        disabled: true,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "feature-monetization.featureTable.currentPlan"
        })
      })
    });
  }
  const purchaseRequest = buyingMotionProps === null || buyingMotionProps === void 0 ? void 0 : buyingMotionProps[productApiName];
  const purchaseOption = purchaseOptionsAndCurrencyByProductApiName !== null && purchaseOptionsAndCurrencyByProductApiName !== void 0 && (_purchaseOptionsAndCu = purchaseOptionsAndCurrencyByProductApiName[productApiName]) !== null && _purchaseOptionsAndCu !== void 0 && _purchaseOptionsAndCu.purchaseOptions ? tryAndGetEligiblePurchaseOptionByTerm(purchaseOptionsAndCurrencyByProductApiName === null || purchaseOptionsAndCurrencyByProductApiName === void 0 || (_purchaseOptionsAndCu2 = purchaseOptionsAndCurrencyByProductApiName[productApiName]) === null || _purchaseOptionsAndCu2 === void 0 ? void 0 : _purchaseOptionsAndCu2.purchaseOptions, term) : undefined;
  const buyingProps = purchaseRequest && purchaseOption ? {
    purchaseRequest,
    commitmentTerm: purchaseOption.commitmentTerm,
    paymentTerm: purchaseOption.paymentTerm
  } : {
    currencyCode: cachedCurrency
  };
  const hasInsuffientBuyingProps = purchaseMotion.toString().includes('BUY') && (!purchaseRequest || !purchaseOption);
  return /*#__PURE__*/_jsx(PurchaseMotionContainer, {
    children: /*#__PURE__*/_jsx(PurchaseMotionCTA, {
      isUpgradePoint: isUpgradePoint,
      ctaProps: Object.assign({}, buyingProps),
      onClick: onPurchaseMotionButtonClick,
      purchaseMotion: hasInsuffientBuyingProps ? 'TALK_TO_SALES_FALLBACK' : purchaseMotion,
      apiName: productApiName,
      location: purchaseMotionLocation,
      trackingData: {
        // @ts-expect-error bender will be available when this is called in app
        app: ((_window$hubspot = window.hubspot) === null || _window$hubspot === void 0 || (_window$hubspot = _window$hubspot.bender) === null || _window$hubspot === void 0 ? void 0 : _window$hubspot.currentProject) || '',
        screen: 'feature-table',
        uniqueId: revenueAttributionUniqueId || 'feature-monetization-category-header'
      }
    })
  });
};